module.exports = __webpack_public_path__ + "static/media/BHB_Logo_English.a03e9f59.png";